import React from 'react';
const PipeShortHorizontalIcon = ({ width = 64, height = 64 }) => {
  const id = React.useId().replace(/:/g, '');
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 112.5 29.924">
      <defs>
        <linearGradient id={`${id}_1`} gradientUnits="userSpaceOnUse" x1="94.2881" y1="-23.0383" x2="123.9873" y2="-23.0383" gradientTransform="matrix(0 -1 1 0 79.2883 124.2117)">
          <stop offset="0.01" stopColor="#646464" />
          <stop offset="0.16" stopColor="#8F8F8F" />
          <stop offset="0.49" stopColor="#DFDFDF" />
          <stop offset="1" stopColor="#646464" />
        </linearGradient>
      </defs>
      <path fill={`url(#${id}_1)`} d="M112.5,29.924H0V0.224h112.5V29.924z" />
    </svg>
  );
};
export default PipeShortHorizontalIcon;
